import { render, staticRenderFns } from "./vf-dialog-widget.vue?vue&type=template&id=34643f3e&scoped=true&"
import script from "./vf-dialog-widget.vue?vue&type=script&lang=js&"
export * from "./vf-dialog-widget.vue?vue&type=script&lang=js&"
import style0 from "./vf-dialog-widget.vue?vue&type=style&index=0&id=34643f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34643f3e",
  null
  
)

export default component.exports